"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var AddButton = (0, material_1.styled)(TextButton_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0.5, 1.5),
        height: theme.spacing(4),
        backgroundColor: theme.palette.common.white,
        border: '1px solid transparent',
        display: 'flex',
        alignItems: ' center',
        letterSpacing: theme.typography.body1.letterSpacing,
        justifyContent: 'flex-end',
        ':hover': { backgroundColor: theme.palette.common.white },
        ':disabled': {
            color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
            opacity: 0.5,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(AddButton, {
    color: 'neutral',
});
